import { customerApi, QueryTag } from '../api';
import { DocumentFamily, DocumentProduct } from '@cas/config/documents';

export enum NotificationType {
  ReleaseNote = 'ReleaseNote',
  TechBulletin = 'TechBulletin',
}

interface NotificationBaseModel {
  id: string;
  isNew: boolean;
  type: NotificationType;
  releaseDate: string;
  downloadUri: string;
  fileSize: number;
  updatedTime: string;
  products: DocumentProduct[];
  productFamilies: DocumentFamily[];
}

export interface NotificationReleaseNoteModel extends NotificationBaseModel {
  type: NotificationType.ReleaseNote;
  version: string;
}

export interface NotificationTechBulletinModel extends NotificationBaseModel {
  type: NotificationType.TechBulletin;
  title: string;
  description: string;
}

export type NotificationModel = NotificationReleaseNoteModel | NotificationTechBulletinModel;

export interface NotificationsModel {
  newCount: number;
  notifications: NotificationModel[];
}

export const notificationsApi = customerApi.injectEndpoints({
  endpoints: build => ({
    getNotifications: build.query<NotificationsModel, void>({
      query: () => 'api/notifications',
      providesTags: [QueryTag.SiteCache, { type: QueryTag.Notification, id: 'Notifications' }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetNotificationsQuery } = notificationsApi;
